module.exports = __webpack_public_path__ + "static/media/britz_logo.4404b405.svg";